import { initializeApp, getApps } from "firebase/app";
import { getAuth, GoogleAuthProvider, signInWithPopup, fetchSignInMethodsForEmail, signOut, setPersistence, inMemoryPersistence } from "firebase/auth";
import { getAnalytics } from "firebase/analytics";
import * as firebaseui from "firebaseui";
import { getCookie, setCookie } from "../../utils";
import config from "./firebase.config";
import { autoLogoutTime, commonAuthDeleteCookies } from "../auth/utils";
import { authStatusCookie, inactivityStartTimeCookie } from "../../utils/cookies";
import { coreLogout } from "../../utils/coreLogout";

function createFunction() {
  // Initialize Firebase app
  const app = !getApps().length ? initializeApp(config) : getApps()[0];
  const analytics = getAnalytics(app);
  // Intialize Auth
  const auth = getAuth(app);
  const providers = [
    GoogleAuthProvider.PROVIDER_ID,
    // firebase.auth.FacebookAuthProvider.PROVIDER_ID,
  ];

  const ui = new firebaseui.auth.AuthUI(auth);

  const signInWithGoogle = () => {
    const provider = new GoogleAuthProvider();
    return signInWithPopup(auth, provider);
  }

  return {
    analytics,
    providers,
    auth,
    ui,
    signInWithGoogle
  };
}

// Making Single instance
let firebaseInstance = null;
export const getFirebaseInstance = function () {
  if (!firebaseInstance) {
    firebaseInstance = createFunction();
  }
  return firebaseInstance;
};


export const isEmailPasswordUser = async (email) => {
  try {
    const { auth } = getFirebaseInstance()

    const methods = await fetchSignInMethodsForEmail(auth, email);
    
    if (methods.includes("password")) {
      return true;
    } else {
      return false;
    }
  } catch (error) {
    console.error("Error checking email:", error.message);
    return false;
  }
};

export const getFirebaseToken = () => {
  return new Promise((resolve, reject) => {
    const { auth } = getFirebaseInstance();
    if (!auth.currentUser) {
      return reject();
    }
    auth.currentUser.getIdToken(false)
      .then((token) => {
        resolve(token);
      })
      .catch((e) => {
        window.location.reload();
        reject(e);
      });
  });
};


export const checkAndSessionTimeout = async (minutes = 60) => {
  
  if (process.env.REACT_APP_ENV === "development") {
    return;
  }

  let ts = getCookie(inactivityStartTimeCookie)
  const parsedTs = Number(ts)
  const authStatus = getCookie(authStatusCookie);
  const isTimeToLogout = (parsedTs && !isNaN(parsedTs) && ((Date.now() - (+ts))) > (minutes * 60 * 1000))  
  
  if ((authStatus === "true") && isTimeToLogout) {
   await coreLogout("/signin")
  } else if ((authStatus !== "true") && ts){ // if more than one tab exists then redirect them to signin if clicked on them later on
    window.location.reload()
  }
};

export const visibilityChangeListner = async () => {
  if (document.visibilityState === "visible") {
    await checkAndSessionTimeout(autoLogoutTime);
  }
};

export const onWindowBlurListener = () => {
  setCookie(inactivityStartTimeCookie, Date.now());
};

export const logout = async (clearStorage = false, redirectTo) => {
  if (clearStorage) {
    localStorage.clear();
  }

  commonAuthDeleteCookies()

  const { auth } = getFirebaseInstance();
  if (auth.currentUser) {
    // Set persistence to in-memory before signing out to prevent auto re-login
    await setPersistence(auth, inMemoryPersistence);
    await signOut(auth);
  }

  if (redirectTo) {
    window.location.href = redirectTo;
  }
};
